import { fetchWithToken } from '@utils/api';
import { API_URL } from '@data/constants';

export interface Recognition {
  id: number;
  name: string;
  eventId: number;
  userId: number;
  displayName: string;
}

export async function fetchRecognitions({
  userId,
}: {
  userId?: number;
} = {}): Promise<Recognition[]> {
  const queryParams = new URLSearchParams();

  if (userId) {
    queryParams.append('userId', userId.toString());
  }

  const response = await fetchWithToken(`${API_URL}/api/recognitions?${queryParams.toString()}`);

  if (!response.ok) {
    throw new Error('Error fetching recognitions');
  }

  const { data } = await response.json() as { data: { count: number, results: Recognition[] }};

  const { results } = data;

  return results;
}